require("./threepl-train-vouchers-table-row.scss");

import {ChangeDetectionStrategy, Component, computed, input, output} from "@angular/core";
import {BzMenuItem} from "@bringoz/ui";
import {bzIconDepot, bzIconErrorOutline, bzIconLocationPinPlusOutline, bzIconMenu} from "@bringoz/ui/icons";
import {TrainVoucher} from "../../models/train-voucher.model";

export type TrainVoucherRowAction = "complete" | "cancel" | "print";

@Component({
  selector: "app-threepl-train-vouchers-table-row",
  templateUrl: "./threepl-train-vouchers-table-row.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {class: "tr"},
})
export class ThreeplTrainVouchersTableRowComponent {
  readonly voucher = input.required<TrainVoucher>();

  readonly voucherSelect = output<TrainVoucher>();
  readonly voucherComplete = output<TrainVoucher>();
  readonly voucherCancel = output<TrainVoucher>();
  readonly voucherPrint = output<TrainVoucher>();

  readonly icons = {comments: bzIconErrorOutline, depot: bzIconDepot, station: bzIconLocationPinPlusOutline, menu: bzIconMenu};

  readonly title = computed(() => {
    const voucher = this.voucher();
    return voucher.threePlExtraData?.name || voucher.externalId || voucher.id;
  });

  readonly comments = computed(() =>
    (this.voucher().threePlExtraData?.carsDetails ?? [])
      .flatMap((car) => car.trainContainerDetails ?? [])
      .map((container) => container.comment)
      .filter((comment): comment is string => !!comment));

  readonly commentsText = computed(() => this.comments().join(", "));

  onMenuSelected(item: BzMenuItem): void {
    const action = item.id as TrainVoucherRowAction;
    const outputs = {complete: this.voucherComplete, cancel: this.voucherCancel, print: this.voucherPrint};
    outputs[action].emit(this.voucher());
  }
}
